import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';

import { useHistory, useParams } from 'react-router-dom';
import { List } from 'immutable';
import Page from 'flow/components/Setting/Page';
import { routes } from 'flow/types/routes';
import { BlockistParams } from 'flow/types/Params';
import {
    deleteCallRouting,
    getBlockLists,
} from 'flow/actions/call-routing-actions';
import Loading from 'flow/components/ui-components/Loading';
import RouteLink from 'flow/components/ui-components/RouteLink';
import useAppContext from 'flow/hooks/useAppContext';
import Button from 'flow/components/ui-components/Button';
import { generatePath } from 'flow/utils/router-utils';

const EditCallRouting = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey, blocklistKey, type } = useParams<BlockistParams>();

    const callRouting = useAppSelector((state) =>
        state.callRoutings.getIn([type, blocklistKey]),
    );

    useEffect(() => {
        dispatch(getBlockLists());
    }, []);

    if (!callRouting) {
        return <Loading />;
    }

    const deleteCallRoutingAndGoBack = () => {
        dispatch(deleteCallRouting(blocklistKey));
        history.push(
            generatePath(
                routes['settings.softphone.advanced.callrouting.type'],
                { extensionKey, type },
            ),
        );
    };

    return (
        <Page
            header={
                callRouting.get('matcher') ||
                callRouting.getIn(['blocklistPredefDTO', 'description'])
            }
            onClickBack={() =>
                history.push(
                    generatePath(
                        routes['settings.softphone.advanced.callrouting.type'],
                        { extensionKey, type },
                    ),
                )
            }
        >
            {type == 'blocked_in' ? (
                <RouteLink
                    to={generatePath(
                        routes[
                            'settings.softphone.advanced.callrouting.type.blocklistKey.action'
                        ],
                        { extensionKey, type, blocklistKey },
                    )}
                    description={callRouting.get('redirect')}
                >
                    {i18next.t('settings.callrouting.action')}
                </RouteLink>
            ) : null}

            <RouteLink
                to={generatePath(
                    routes[
                        'settings.softphone.advanced.callrouting.type.blocklistKey.exception'
                    ],
                    { extensionKey, type, blocklistKey },
                )}
                description={callRouting
                    .get('blocklistExceptions', List())
                    .count()}
            >
                {i18next.t('settings.callrouting.exceptions')}
            </RouteLink>

            <p className="p-2 text-xs text-gray-500">
                {i18next.t('settings.callrouting.exceptions.helptext')}
            </p>

            <RouteLink
                to={generatePath(
                    routes[
                        'settings.softphone.advanced.callrouting.type.blocklistKey.during'
                    ],
                    { extensionKey, type, blocklistKey },
                )}
                description={
                    callRouting.getIn(['profileDTO', 'description']) ||
                    i18next.t('settings.callrouting.profile.allprofiles')
                }
            >
                {i18next.t('settings.callrouting.during')}
            </RouteLink>

            <Button
                onClick={deleteCallRoutingAndGoBack}
                color="danger"
                className="my-3"
            >
                {i18next.t('settings.callrouting.delete.redirect')}
            </Button>
        </Page>
    );
};

export default EditCallRouting;
